@if (hasAppSettingsContent) {
<mat-toolbar id="searchBar">
  <div class="extraInput">
    <section>
      @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DATABASE, ModuleTypeEnum.DATABASE_GROUP, SubModuleTypeEnum.DATABASE_GROUP_INFO_APP_SETTINGS_ADDED)) {
        <button mat-flat-button color="primary" [matMenuTriggerFor]="createMenu">
          Créer un app settings
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #createMenu="matMenu">
          @for (option of appSettingsOptions; track option.id) {
            <button mat-menu-item
              (click)="openAppSettingsImportationDialog(option.id)">
              {{ option.label }}
            </button>
          }
        </mat-menu>
      }
    </section>
  </div>
</mat-toolbar>
}
@if (!isMedispringHost) {
  <div class="warning-box">
    Cette section dépend du Desktop API. Si elle reste vide, c'est que vous êtes sur une URL qui n'est pas *.medispring.be (❤️ CORS ❤️).
  </div>
}
<table mat-table matSort [dataSource]="dataSource">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
    <td mat-cell *matCellDef="let element">{{element?.id}}</td>
  </ng-container>
  <ng-container matColumnDef="encrypted">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Crypté</th>
    <td mat-cell *matCellDef="let element">
      @if (element?.encrypted) {
        <mat-icon class="encrypted-icon">lock</mat-icon>
      }
      @if (!element?.encrypted) {
        <mat-icon class="not-encrypted-icon">lock_open</mat-icon>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="settings">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Settings</th>
    <td mat-cell *matCellDef="let element">{{element?.settings}}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
